import React from "react";
import {connect} from "react-redux";
import {CONTEXT_MENU_TYPE} from "../../../../../constants";
import ContextmenuList from "./contextmenu/contextmenuList";
import ContextmenuButtons from "./contextmenu/contextmenuButtons";

const SqftContextMenu = (props) => {
  const {contextMenuType} = props;

  switch (contextMenuType) {
    case CONTEXT_MENU_TYPE.list:
      return <ContextmenuList {...props}/>
    case CONTEXT_MENU_TYPE.buttons:
      return <ContextmenuButtons {...props}/>
  }
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftContextMenu);

